// Code generated by protoc-gen-ts. DO NOT EDIT.
// protoc-gen-ts is an Art Processors production, found in mos-sdk-py.

import { Metadata } from "generated/mos/entity";
import { BundleType, BundleTypeValues } from "generated/mos/releasecontrols";
import { Codec, DecodeContext, RemoteObject, WebRPCError, decodeMessageRepeated, ensureScalar } from "generated/webrpc";

// 
// A Bundle represents a single published bundle. The url value
// will only be populated once processing_status is COMPLETE.
export namespace Bundle {
  export type Ref = { readonly typename: 'mos.org.getty.publish.Bundle', readonly id: string };
  export function isRef(v: { typename: string, id: string } | undefined): v is Ref {
    return !!v && typeof v.id === "string" && (v.typename === 'mos.org.getty.publish.Bundle');
  }
  export function mustRef(v: { typename: string, id: string } | undefined): Ref {
    if (!isRef(v)) throw new WebRPCError(`Ref ${v && v.typename}:${v && v.id} is not a valid ref for a Bundle`);
    return v;
  }
  export const refName = "mos.org.getty.publish.Bundle" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly ref: { readonly typename: 'mos.org.getty.publish.Bundle', readonly id: string } | undefined,
    readonly metadata: Metadata.Entity | undefined,
    readonly bundleType: BundleType,
    readonly processingStatus: BundleProcessingStatus,
    readonly url: string,
    readonly releaseRef: { readonly typename: 'mos.org.getty.publish.Release', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    ref: undefined,
    metadata: undefined,
    bundleType: "BUNDLE_TYPE_UNSPECIFIED",
    processingStatus: "BUNDLE_PROCESSING_UNSPECIFIED",
    url: "",
    releaseRef: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["ref"] = v.ref;
      obj["metadata"] = Metadata.codec.encode(v.metadata);
      obj["bundleType"] = v.bundleType;
      obj["processingStatus"] = v.processingStatus;
      obj["url"] = v.url;
      obj["releaseRef"] = v.releaseRef;
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.publish.Bundle");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["ref"] = v["ref"];
      out["metadata"] = ctx.decode(Metadata.codec, v["metadata"], "metadata");
      {
        const ev = ensureScalar(ctx, v["bundleType"], "string") || defaults["bundleType"];
        if (!BundleTypeValues.has(ev as any)) {
          throw ctx.error(`unknown value "${ev}" for enum .mos.release_controls.BundleType`);
        }
        out["bundleType"] = ev as any;
      }
      {
        const ev = ensureScalar(ctx, v["processingStatus"], "string") || defaults["processingStatus"];
        if (!BundleProcessingStatusValues.has(ev as any)) {
          throw ctx.error(`unknown value "${ev}" for enum .mos.org.getty.publish.BundleProcessingStatus`);
        }
        out["processingStatus"] = ev as any;
      }
      out["url"] = ensureScalar(ctx, v["url"], "string");
      out["releaseRef"] = v["releaseRef"];
      return out as any as Entity;
    }
  }();
}

export const BundleProcessingStatusValues = new Set([
  'BUNDLE_PROCESSING_UNSPECIFIED' as const,
  'BUNDLE_PROCESSING_RUNNING' as const,
  'BUNDLE_PROCESSING_COMPLETED' as const,
  'BUNDLE_PROCESSING_FAILED' as const,
]);
export type BundleProcessingStatus = typeof BundleProcessingStatusValues extends Set<infer U> ? U : never;

// 
// A BundleSummary is a pre-publish overview of a Bundle.
// It includes:
// - counts of entities that are selected for inclusion in the Bundle
// - a link to the most recently published Bundle of that type
// - the count of changed entities since the bundle was last published
// - the count of entities with issues included in the bundle
// It is provided to give the user an overview of what they are
// about to release if they choose to publish.
export namespace BundleSummary {
  export const refName = "mos.org.getty.publish.BundleSummary" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly bundleType: BundleType,
    readonly entityCounts: ReadonlyArray<BundleSummary.EntityCount.Entity>,
    readonly unpublishedChangeCount: number,
    readonly lastPublishedBundle: Bundle.Entity | undefined,
    readonly issueCount: number,
  }
  export const defaults: Entity = {
    type: refName,
    bundleType: "BUNDLE_TYPE_UNSPECIFIED",
    entityCounts: [],
    unpublishedChangeCount: 0,
    lastPublishedBundle: undefined,
    issueCount: 0,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["bundleType"] = v.bundleType;
      obj["entityCounts"] = [];
      for (const item of v.entityCounts) {
        obj["entityCounts"].push(BundleSummary.EntityCount.codec.encode(item));
      }
      obj["unpublishedChangeCount"] = v.unpublishedChangeCount;
      obj["lastPublishedBundle"] = Bundle.codec.encode(v.lastPublishedBundle);
      obj["issueCount"] = v.issueCount;
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.publish.BundleSummary");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      {
        const ev = ensureScalar(ctx, v["bundleType"], "string") || defaults["bundleType"];
        if (!BundleTypeValues.has(ev as any)) {
          throw ctx.error(`unknown value "${ev}" for enum .mos.release_controls.BundleType`);
        }
        out["bundleType"] = ev as any;
      }
      out["entityCounts"] = decodeMessageRepeated(ctx, BundleSummary.EntityCount.codec, v["entityCounts"], "entityCounts");
      out["unpublishedChangeCount"] = ensureScalar(ctx, v["unpublishedChangeCount"], "number");
      out["lastPublishedBundle"] = ctx.decode(Bundle.codec, v["lastPublishedBundle"], "lastPublishedBundle");
      out["issueCount"] = ensureScalar(ctx, v["issueCount"], "number");
      return out as any as Entity;
    }
  }();
  export namespace EntityCount {
    export const refName = "mos.org.getty.publish.BundleSummary.EntityCount" as const;
    export type Entity = {
      readonly type: typeof refName,
      readonly entityDisplayName: string,
      readonly entityTypename: string,
      readonly count: number,
    }
    export const defaults: Entity = {
      type: refName,
      entityDisplayName: "",
      entityTypename: "",
      count: 0,
    }
    export const codec: Codec<Entity> = new class {
      public encode(v: Entity): RemoteObject;
      public encode(v: Entity | undefined): RemoteObject | null {
        if (!v) return null;
        const { type, ...out } = v;
        return out;
      }
      public decode(v: RemoteObject): Entity;
      public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
        if (v === undefined || v === null) return undefined;
        if (!ctx) ctx = new DecodeContext(".mos.org.getty.publish.BundleSummary.EntityCount");
        if (typeof(v) !== "object") throw ctx.expected("object", v);
        const out: RemoteObject = { ...defaults };
        out["entityDisplayName"] = ensureScalar(ctx, v["entityDisplayName"], "string");
        out["entityTypename"] = ensureScalar(ctx, v["entityTypename"], "string");
        out["count"] = ensureScalar(ctx, v["count"], "number");
        return out as any as Entity;
      }
    }();
  }

}

// 
// A Release is a process that produces one or more Bundles
export namespace Release {
  export type Ref = { readonly typename: 'mos.org.getty.publish.Release', readonly id: string };
  export function isRef(v: { typename: string, id: string } | undefined): v is Ref {
    return !!v && typeof v.id === "string" && (v.typename === 'mos.org.getty.publish.Release');
  }
  export function mustRef(v: { typename: string, id: string } | undefined): Ref {
    if (!isRef(v)) throw new WebRPCError(`Ref ${v && v.typename}:${v && v.id} is not a valid ref for a Release`);
    return v;
  }
  export const refName = "mos.org.getty.publish.Release" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly ref: { readonly typename: 'mos.org.getty.publish.Release', readonly id: string } | undefined,
    readonly metadata: Metadata.Entity | undefined,
    readonly releaseNotes: string,
    readonly bundles: ReadonlyArray<Bundle.Entity>,
  }
  export const defaults: Entity = {
    type: refName,
    ref: undefined,
    metadata: undefined,
    releaseNotes: "",
    bundles: [],
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["ref"] = v.ref;
      obj["metadata"] = Metadata.codec.encode(v.metadata);
      obj["releaseNotes"] = v.releaseNotes;
      obj["bundles"] = [];
      for (const item of v.bundles) {
        obj["bundles"].push(Bundle.codec.encode(item));
      }
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.publish.Release");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["ref"] = v["ref"];
      out["metadata"] = ctx.decode(Metadata.codec, v["metadata"], "metadata");
      out["releaseNotes"] = ensureScalar(ctx, v["releaseNotes"], "string");
      out["bundles"] = decodeMessageRepeated(ctx, Bundle.codec, v["bundles"], "bundles");
      return out as any as Entity;
    }
  }();
}

